/* eslint-disable class-methods-use-this */
import EVENT from '../enums/event.js';
import STATE from '../enums/state.js';

class Megamenu extends HTMLElement {
  constructor() {
    super();

    this.state = STATE.MEGAMENU.CLOSED;

    this.transitioning = {
      currently: false,
      to: null,
    };

    document.addEventListener('DOMContentLoaded', () => {
      this.classList.remove('lg:h-[465px]', 'lg:hidden');

      this.triggers = [...document.querySelectorAll('[data-menu-trigger]')];

      this.initialiseEventListeners();
    });
  }

  openMenu(key) {
    const menus = [...document.querySelectorAll('[data-menu]')];

    menus.forEach(menu => menu.classList.add('lg:hidden'));
    menus.find(menu => menu.dataset.menu === key).classList.remove('lg:hidden');
  }

  setTransitioning(currently, to = null) {
    this.transitioning = {
      currently,
      to,
    };
  }

  open() {
    this.classList.add('lg:h-[465px]');
    this.classList.remove('lg:h-0');

    this.state = STATE.MEGAMENU.OPEN;

    this.setTransitioning(false);

    window.addEventListener('scroll', () => this.closeOnScroll());
  }

  closeWithDelay() {
    setTimeout(() => {
      if (!this.transitioning.currently) {
        return;
      }

      this.close();
    }, 250);
  }

  close() {
    this.classList.remove('lg:h-[465px]');
    this.classList.add('lg:h-0');

    this.state = STATE.MEGAMENU.CLOSED;

    this.setTransitioning(false);

    window.removeEventListener('scroll', () => this.closeOnScroll());
  }

  closeImmediately() {
    this.classList.add('invisible', 'hidden');

    this.close();
    setTimeout(() => {
      this.classList.remove('invisible', 'hidden');
    }, 500);
  }

  closeOnScroll() {
    this.closeImmediately();
  }

  transitionState(from, to) {
    const wasAlreadyTransitioning = this.transitioning.currently;

    this.setTransitioning(true, to);

    if (to === STATE.MEGAMENU.OPEN) {
      return this.open();
    }

    if (to === STATE.MEGAMENU.CLOSED && wasAlreadyTransitioning) {
      this.setTransitioning(true, STATE.MEGAMENU.OPEN);
      return this.open();
    }

    return this.closeWithDelay();
  }

  initialiseEventListeners() {
    this.triggers.forEach(trigger => this.addTriggerEventListeners(trigger));

    this.addEventListener('mouseover', () => {
      this.transitionState(this.state, STATE.MEGAMENU.OPEN);
    });

    this.addEventListener('mouseout', () => {
      this.transitionState(this.state, STATE.MEGAMENU.CLOSED);
    });

    document.addEventListener(EVENT.HEADER.HIDDEN, () => {
      setTimeout(() => {
        this.moveMegamenu();
      }, 500);
    });

    document.addEventListener(EVENT.HEADER.VISIBLE, () => {
      setTimeout(() => {
        this.moveMegamenu();
      }, 500);
    });
  }

  moveMegamenu() {
    // Don't move the menu position on mobile devices
    const media = window.matchMedia('(max-width:767px)');
    if (media.matches) {
      return;
    }

    // Adjust the Megamenu top if the Scrolling Marquee is visible or not.
    const headerRectangle = document
      .querySelector('#shopify-section-header')
      .getBoundingClientRect();

    const bannerRectangle = document
      .querySelector('[data-section="top-banner"]')
      .getBoundingClientRect();

    // Take the difference between the header top and banner height.
    const topPosition = -1 * (bannerRectangle.height - headerRectangle.top);

    this.style.top = `${topPosition}px`;
  }

  addTriggerEventListeners(trigger) {
    ['mouseenter', 'mouseleave'].forEach(ev => {
      trigger.addEventListener(ev, () => {
        this.openMenu(trigger.dataset.menuTrigger);
        this.transitionState(this.state, Number(!this.state));
      });
    });
  }
}

customElements.define('mega-menu', Megamenu);
